/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { AttachmentDeleteResponse } from './attachmentDeleteResponse';

export type GenericApiResponseAttachmentDeleteResponseData = AttachmentDeleteResponse | null;
